<div class="dash-container">

  <!-- ════════════════ PAGE HEADER ════════════════ -->
  <div class="dash-page-header">
    <div class="dph-left">
      <div class="dph-badge">
        <i class="fa-solid fa-shapes"></i> Gestão de Projectos
      </div>
      <h1 class="dph-title">As Minhas Campanhas</h1>
      <p class="dph-subtitle">
        Acompanhe o estado das suas submissões, gerencie rascunhos e visualize o progresso financeiro das suas
        iniciativas.
      </p>
    </div>

    <div class="dph-actions">
      <a routerLink="/criar-campanha" class="btn btn-primary">
        <i class="fa-solid fa-plus"></i> Criar Nova Campanha
      </a>
    </div>
  </div>

  <!-- ════════════════ KPI CARDS ════════════════ -->
  <div class="kpi-grid">
    <!-- Activas -->
    <div class="kpi-card kpi-green">
      <div class="kpi-icon"><i class="fa-solid fa-bolt"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ ((indicadores["Em curso"] || 0) + (indicadores["Publicado"] || 0))
          }}</ng-container>
        <p-skeleton width="3rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Campanhas Activas</div>
      <span class="kpi-delta up"><i class="fa-solid fa-arrow-trend-up"></i> Em angariação</span>
    </div>

    <!-- Pendentes -->
    <div class="kpi-card kpi-blue">
      <div class="kpi-icon"><i class="fa-solid fa-hourglass-half"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ indicadores["Pendente"] || "0" }}</ng-container>
        <p-skeleton width="3rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Em Análise / Pendentes</div>
      <span class="kpi-delta neu"><i class="fa-solid fa-clock"></i> Aguarda validação</span>
    </div>

    <!-- Rascunhos -->
    <div class="kpi-card kpi-purple">
      <div class="kpi-icon"><i class="fa-solid fa-file-pen"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ indicadores["Rascunho"] || "0" }}</ng-container>
        <p-skeleton width="3rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Rascunhos</div>
      <span class="kpi-delta neu"><i class="fa-solid fa-pencil"></i> Não publicadas</span>
    </div>

    <!-- Concluídas -->
    <div class="kpi-card kpi-amber">
      <div class="kpi-icon"><i class="fa-solid fa-circle-check"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ indicadores["Encerrado"] || "0" }}</ng-container>
        <p-skeleton width="3rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Campanhas Encerradas</div>
      <span class="kpi-delta up"><i class="fa-solid fa-flag-checkered"></i> Concluídas</span>
    </div>

    <!-- Recusadas -->
    <div class="kpi-card kpi-red">
      <div class="kpi-icon"><i class="fa-solid fa-triangle-exclamation"></i></div>
      <div class="kpi-value">
        <ng-container *ngIf="!loadIndicators">{{ indicadores["Recusado"] || "0" }}</ng-container>
        <p-skeleton width="3rem" height="1.8rem" *ngIf="loadIndicators"></p-skeleton>
      </div>
      <div class="kpi-label">Requerem Revisão</div>
      <span class="kpi-delta down"><i class="fa-solid fa-info-circle"></i> Recusadas</span>
    </div>
  </div>

  <!-- ════════════════ FILTROS & LISTAGEM ════════════════ -->
  <div class="dash-section-card">
    <div class="dsc-header">
      <div class="dsc-title">
        <i class="fa-solid fa-list-check"></i> Listagem de Projectos
        <span class="dsc-count" *ngIf="pagination.totalRecords !== undefined">({{ pagination.totalRecords }})</span>
      </div>
    </div>

    <!-- Barra de Filtros -->
    <div class="dsc-filter-bar">
      <form [formGroup]="formFilters" class="filter-form-grid">
        <div class="filter-field">
          <label class="ff-label" for="DataInicio"><i class="fa-regular fa-calendar"></i> Data de Criação</label>
          <p-datepicker formControlName="DataInicio" id="DataInicio" class="w-full" [showIcon]="true"
            dateFormat="dd/mm/yy" placeholder="Filtrar por data..." [showClear]="true" appendTo="body"></p-datepicker>
        </div>

        <div class="filter-field">
          <label class="ff-label" for="CategoriaId"><i class="fa-solid fa-shapes"></i> Sector / Categoria</label>
          <p-select formControlName="CategoriaId" id="CategoriaId" class="w-full" placeholder="Todos os Sectores"
            [options]="categoriaList" optionLabel="label" optionValue="id" filter="true" [showClear]="true"></p-select>
        </div>

        <div class="filter-field">
          <label class="ff-label" for="EstadoCampanhaENUM"><i class="fa-solid fa-traffic-light"></i> Estado da
            Campanha</label>
          <p-select formControlName="EstadoCampanhaENUM" id="EstadoCampanhaENUM" class="w-full"
            placeholder="Todos os Estados" [options]="estadoList" optionLabel="label" optionValue="id" filter="true"
            [showClear]="true"></p-select>
        </div>
      </form>
    </div>

    <!-- LISTA DE CAMPANHAS -->
    <div class="dsc-body">
      <!-- Loading State -->
      <ng-container *ngIf="loading; else dataState">
        <app-skeleton-loader [count]="5" type="card-campanha-dash"></app-skeleton-loader>
      </ng-container>

      <ng-template #dataState>
        <ng-container *ngIf="pagination.data?.length; else noData">
          <div class="campaigns-table-list">
            <app-card-campanha-dash *ngFor="let item of pagination.data" [codigo]="item.id" [titulo]="item.titulo"
              [Sector]="item?.categoria?.descricao" [Objectivo]="item.metaArrecadar" [Arrecadado]="item.valorArrecado"
              [estado]="item.estadoCampanha" [DataCriacao]="item.dataCriacaoFormatada"
              [actions]="getActionsByEstado(item)" (menuOpened)="setOpenedMenu($event)"
              (rowClick)="verDetalhe(item)"></app-card-campanha-dash>
          </div>

          <!-- Paginador -->
          <div class="pagination-wrap">
            <app-paginator-control [first]="((pagination.pageNumber ?? 1) - 1) * (pagination.pageSize ?? 10)"
              [rows]="pagination.pageSize ?? 10" [totalRecords]="pagination.totalRecords ?? 0"
              (pageChange)="onPageChange($event)"></app-paginator-control>
          </div>
        </ng-container>

        <ng-template #noData>
          <div class="empty-state-box">
            <app-data-void titulo="Nenhuma campanha encontrada"
              descricao="Não foram encontradas campanhas com os critérios de pesquisa seleccionados."></app-data-void>
          </div>
        </ng-template>
      </ng-template>
    </div>
  </div>
</div>

<!-- ════════════════ DIALOG PRORROGAR DATA ════════════════ -->
<p-dialog header="Solicitar Prorrogação da Campanha" [(visible)]="showDialogExtend" [modal]="true" [closable]="true"
  [style]="{ width: '92vw', 'max-width': '520px' }">
  <div class="extend-dialog-body">
    <div class="ed-info-banner">
      <i class="fa-solid fa-circle-info"></i>
      <span>A solicitação de prorrogação será avaliada pela equipa de moderação do FundCube.</span>
    </div>

    <form [formGroup]="formExtendDate" class="extend-form">
      <div class="form-group mb-4">
        <label class="form-label" for="dataAntiga">Data de Término Actual</label>
        <p-datePicker formControlName="dataAntiga" id="dataAntiga" dateFormat="dd/mm/yy" class="w-full"
          [showIcon]="true" appendTo="body"></p-datePicker>
      </div>

      <div class="form-group mb-4">
        <label class="form-label">Prorrogar Duração (Dias) <span class="text-red-500">*</span></label>
        <div class="extend-pills-grid">
          <div class="extend-pill" *ngFor="let d of diasList"
            [class.active]="formExtendDate.get('dias')?.value === d.key"
            (click)="formExtendDate.get('dias')?.setValue(d.key)">
            <span class="ep-num">{{ d.name }}</span>
            <span class="ep-label">dias</span>
          </div>
        </div>
        <small class="field-error" *ngIf="formExtendDate.get('dias')?.invalid && formExtendDate.get('dias')?.touched">
          <i class="fa-solid fa-triangle-exclamation"></i> Por favor seleccione o número de dias.
        </small>
      </div>

      <div class="form-group">
        <label class="form-label" for="motivo">Motivo da Solicitação <span class="text-red-500">*</span></label>
        <textarea rows="4" pTextarea formControlName="motivo" id="motivo"
          placeholder="Descreva detalhadamente a justificação para a extensão do prazo..."
          class="form-textarea w-full"></textarea>
        <small class="field-error"
          *ngIf="formExtendDate.get('motivo')?.invalid && formExtendDate.get('motivo')?.touched">
          <i class="fa-solid fa-triangle-exclamation"></i> O motivo é obrigatório.
        </small>
      </div>
    </form>

    <div class="extend-dialog-actions mt-5">
      <button type="button" class="btn btn-ghost" (click)="close()">
        Cancelar
      </button>
      <button type="button" class="btn btn-primary" (click)="extendCampanha()"
        [disabled]="formExtendDate.invalid || loading">
        <i class="fa-solid fa-spinner fa-spin" *ngIf="loading"></i>
        <i class="fa-solid fa-paper-plane" *ngIf="!loading"></i>
        {{ loading ? "A enviar..." : "Submeter Solicitação" }}
      </button>
    </div>
  </div>
</p-dialog>

<!-- ════════════════ DRAWER DETALHE CAMPANHA ════════════════ -->
<p-drawer [(visible)]="visible" position="right" [style]="{ width: '95vw', 'max-width': '650px' }"
  styleClass="!w-full md:!w-80 lg:!w-[34rem]" appendTo="body" [blockScroll]="true" [modal]="true">
  <ng-template #headless>
    <div class="drawer-body-wrapper">
      @if (campanhaSelecionada) {
      <app-admin-detalhe-campanha [campanha]="campanhaSelecionada" (onCloseModal)="visible = false"
        [showExtend]="false" />
      }
    </div>
  </ng-template>
</p-drawer>